<template>
  <div>
    <v-tabs>

      <v-tab href="#tab-common">
        Common
      </v-tab>
      <v-tab-item value="tab-common">
          <SuperBomDetail></SuperBomDetail>
      </v-tab-item>

      <v-tab href="#tab-components-manage">
        Components (Manage)
      </v-tab>
      <v-tab-item value="tab-components-manage">
        <SuperBomComponentList></SuperBomComponentList>
      </v-tab-item>

      <v-tab href="#tab-components-auto">
        Components (Auto manage)
      </v-tab>
      <v-tab-item value="tab-components-auto">
        <SuperBomComponentAutoList></SuperBomComponentAutoList>
      </v-tab-item>

      <v-tab href="#tab-components-width">
        Components (Width)
      </v-tab>
      <v-tab-item value="tab-components-width">
        <SuperBomComponentWidthList></SuperBomComponentWidthList>
      </v-tab-item>

    </v-tabs>

  </div>
</template>

<script>
import SuperBomComponentList from "@/components/SuperBom/SuperBomComponentList";
import SuperBomComponentWidthList from "@/components/SuperBom/SuperBomComponentWidthList";
import SuperBomComponentAutoList from "@/components/SuperBom/SuperBomComponentAutoList";
import {mapGetters, mapActions} from 'vuex'
import SuperBomDetail from "@/components/SuperBom/SuperBomDetail";

export default {
  name: 'SuperBom',

  components: {
    SuperBomDetail,
    SuperBomComponentList,
    SuperBomComponentWidthList,
    SuperBomComponentAutoList,
  },
  methods: {
    ...mapActions(['fetchSuperBom']),
  },
  mounted() {
    this.fetchSuperBom(this.$route.params.superBomId)
  }
}
</script>